// Add here the components that you want to bootstrap on PHP pages
import { NgModuleFactory, Type } from '@angular/core';
import { NavigationSecondaryAboutComponent } from '../app/navigation/navigation-secondary/navigation-secondary-about.component';
import { NavigationSecondaryCommunityComponent } from '../app/navigation/navigation-secondary/navigation-secondary-community.component';
import { NavigationSecondaryContestsComponent } from '../app/navigation/navigation-secondary/navigation-secondary-contests.component';
import { NavigationSecondaryFinancesComponent } from '../app/navigation/navigation-secondary/navigation-secondary-finances.component';
import { NavigationSecondaryHelpComponent } from '../app/navigation/navigation-secondary/navigation-secondary-help.component';
import { NavigationSecondaryHireFreelancersComponent } from '../app/navigation/navigation-secondary/navigation-secondary-hire-freelancers.component';
import { NavigationSecondaryLocalJobsComponent } from '../app/navigation/navigation-secondary/navigation-secondary-local-jobs.component';
import { NavigationSecondaryMySkillsComponent } from '../app/navigation/navigation-secondary/navigation-secondary-my-skills.component';
import { NavigationSecondaryPortfolioComponent } from '../app/navigation/navigation-secondary/navigation-secondary-portfolio.component';
import { NavigationSecondaryProfileComponent } from '../app/navigation/navigation-secondary/navigation-secondary-profile.component';
import { NavigationSecondaryProjectsComponent } from '../app/navigation/navigation-secondary/navigation-secondary-projects.component';
import { NavigationSecondaryShowcaseComponent } from '../app/navigation/navigation-secondary/navigation-secondary-showcase.component';
import { CompatABTestComponent } from './compat-abtest.component';
import { CompatMessagingComponent } from './compat-messaging.component';
import { CompatModalsComponent } from './compat-modals.component';
import { CompatNavigationEmptyComponent } from './compat-navigation-empty.component';
import { CompatNavigationComponent } from './compat-navigation.component';
import { CompatTasklistComponent } from './compat-tasklist.component';
import { CompatThreatmetrixComponent } from './compat-threatmetrix.component';
import { CompatTrackingComponent } from './compat-tracking.component';

export interface LazyComponent {
  readonly selector: string;
  readonly component: Type<any>;
  readonly index?: number;
  loadModule(): Promise<Type<any> | NgModuleFactory<any>>;
}

export const components: readonly LazyComponent[] = [
  {
    selector: 'webapp-compat-tracking',
    loadModule: () =>
      import('compat/compat-tracking.module').then(m => m.CompatTrackingModule),
    component: CompatTrackingComponent,
  },
  {
    selector: 'webapp-compat-navigation',
    loadModule: () =>
      import('compat/compat-navigation.module').then(
        m => m.CompatNavigationModule,
      ),
    component: CompatNavigationComponent,
    index: 0,
  },
  {
    selector: 'webapp-compat-navigation-empty',
    loadModule: () =>
      import('compat/compat-navigation-empty.module').then(
        m => m.CompatNavigationEmptyModule,
      ),
    component: CompatNavigationEmptyComponent,
    index: 0,
  },
  {
    selector: 'webapp-compat-navigation-secondary-projects',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-projects.module'
      ).then(m => m.NavigationSecondaryProjectsModule),
    component: NavigationSecondaryProjectsComponent,
  },
  {
    selector: 'webapp-compat-navigation-secondary-about',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-about.module'
      ).then(m => m.NavigationSecondaryAboutModule),
    component: NavigationSecondaryAboutComponent,
  },
  {
    selector: 'webapp-compat-navigation-secondary-contests',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-contests.module'
      ).then(m => m.NavigationSecondaryContestsModule),
    component: NavigationSecondaryContestsComponent,
  },
  {
    selector: 'webapp-compat-navigation-secondary-community',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-community.module'
      ).then(m => m.NavigationSecondaryCommunityModule),
    component: NavigationSecondaryCommunityComponent,
  },
  {
    selector: 'webapp-compat-navigation-secondary-profile',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-profile.module'
      ).then(m => m.NavigationSecondaryProfileModule),
    component: NavigationSecondaryProfileComponent,
  },
  {
    selector: 'webapp-compat-navigation-secondary-showcase',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-showcase.module'
      ).then(m => m.NavigationSecondaryShowcaseModule),
    component: NavigationSecondaryShowcaseComponent,
  },
  {
    selector: 'webapp-compat-navigation-secondary-portfolio',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-portfolio.module'
      ).then(m => m.NavigationSecondaryPortfolioModule),
    component: NavigationSecondaryPortfolioComponent,
  },
  {
    selector: 'webapp-compat-navigation-secondary-local-jobs',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-local-jobs.module'
      ).then(m => m.NavigationSecondaryLocalJobsModule),
    component: NavigationSecondaryLocalJobsComponent,
  },
  {
    selector: 'webapp-compat-navigation-secondary-finances',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-finances.module'
      ).then(m => m.NavigationSecondaryFinancesModule),
    component: NavigationSecondaryFinancesComponent,
  },
  {
    selector: 'webapp-compat-navigation-secondary-my-skills',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-my-skills.module'
      ).then(m => m.NavigationSecondaryMySkillsModule),
    component: NavigationSecondaryMySkillsComponent,
  },
  {
    selector: 'webapp-compat-navigation-secondary-hire-freelancers',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-hire-freelancers.module'
      ).then(m => m.NavigationSecondaryHireFreelancersModule),
    component: NavigationSecondaryHireFreelancersComponent,
  },
  {
    selector: 'webapp-compat-navigation-secondary-help',
    loadModule: () =>
      import(
        'app/navigation/navigation-secondary/navigation-secondary-help.module'
      ).then(m => m.NavigationSecondaryHelpModule),
    component: NavigationSecondaryHelpComponent,
  },
  {
    selector: 'webapp-compat-messaging',
    loadModule: () =>
      import('compat/compat-messaging.module').then(
        m => m.CompatMessagingModule,
      ),
    component: CompatMessagingComponent,
  },
  {
    selector: 'webapp-compat-modals',
    loadModule: () =>
      import('compat/compat-modals.module').then(m => m.CompatModalsModule),
    component: CompatModalsComponent,
  },
  {
    selector: 'webapp-compat-abtest',
    loadModule: () =>
      import('compat/compat-abtest.module').then(m => m.CompatABTestModule),
    component: CompatABTestComponent,
  },
  {
    selector: 'webapp-compat-tasklist',
    loadModule: () =>
      import('compat/compat-tasklist.module').then(m => m.CompatTasklistModule),
    component: CompatTasklistComponent,
  },
  {
    selector: 'webapp-compat-threatmetrix',
    loadModule: () =>
      import('compat/compat-threatmetrix.module').then(
        m => m.CompatThreatmetrixModule,
      ),
    component: CompatThreatmetrixComponent,
  },
];
